/* eslint-disable stylistic/quote-props */
import { cn } from "../util.cn";

const shadowMap = {
  "1": "shadow-1",
  "2": "shadow-2",
  "3": "shadow-3",
  "4": "shadow-4",
  "5": "shadow-5",
  "6": "shadow-6",
} as const;
type ShadowKey = keyof typeof shadowMap;

const roundedMap = {
  "1": "rounded-1",
  "2": "rounded-2",
  "3": "rounded-3",
  "4": "rounded-4",
  "5": "rounded-5",
  "6": "rounded-6",
  full: "full",
} as const;
type RoundedKey = keyof typeof roundedMap;

const lineClampMap = {
  "1": "line-clamp-1",
  "2": "line-clamp-2",
  "3": "line-clamp-3",
  "4": "line-clamp-4",
  "5": "line-clamp-5",
  "6": "line-clamp-6",
  none: "line-clamp-none",
} as const;
type LineClampKey = keyof typeof lineClampMap;

const leadingMap = {
  "1": "leading-1",
  "2": "leading-2",
  "3": "leading-3",
  "4": "leading-4",
  "5": "leading-5",
  "6": "leading-6",
  "7": "leading-7",
  "8": "leading-8",
  "9": "leading-9",
  "10": "leading-10",
} as const;
type LeadingKey = keyof typeof leadingMap;

const objectMap = {
  contain: "object-contain",
  cover: "object-cover",
  fill: "object-fill",
  none: "object-none",
  "scale-down": "object-scale-down",
} as const;
type ObjectKey = keyof typeof objectMap;

interface PttProps {
  className: string | undefined;

  leading?: LeadingKey;
  lineClamp?: LineClampKey;
  object?: ObjectKey;
  rounded?: RoundedKey;
  shadow?: ShadowKey;
}

const ptt = (props: PttProps): string => {
  const { className, leading, lineClamp, object, rounded, shadow } = props;

  return cn(
    className,
    leading && leadingMap[leading],
    lineClamp && lineClampMap[lineClamp],
    rounded && roundedMap[rounded],
    object && objectMap[object],
    shadow && shadowMap[shadow],
  );
};

export { type PttProps, ptt };
